import {useWhiteboardStore} from '@modules/whiteboard'
import {classNames, observer, React} from '@api'
import {useObserver} from 'mobx-react-lite'
import {breakpoints} from '~components/breakpoints'
import {Tooltip} from '~components/Tooltip'
import * as css from './ToolButton.css'

export interface ToolButtonProps {
  onClick?: () => void
  onSelect?: () => void
  onDoubleClick?: () => void
  disabled?: boolean
  isActive?: boolean
  isSponsor?: boolean
  isToolLocked?: boolean
  variant?: 'icon' | 'text' | 'circle' | 'primary'
  children: React.ReactNode
  className?: string
}

export const ToolButton = React.forwardRef<HTMLButtonElement, ToolButtonProps>(
  (
    {
      onSelect,
      onClick,
      onDoubleClick,
      variant,
      children,
      isToolLocked = false,
      disabled = false,
      isActive = false,
      isSponsor = false,
      className,
      ...rest
    },
    ref
  ) => {
    return useObserver(() => (
      <button
        ref={ref}
        data-active={isActive}
        data-variant={variant}
        onClick={onClick}
        disabled={disabled}
        onPointerDown={onSelect}
        onDoubleClick={onDoubleClick}
        {...rest}
        className={classNames(css.root, className)}
      >
        <div className={css.inner}>{children}</div>
        {isToolLocked && <div className={css.toolLockIndicator}/>}
      </button>
    ))
  }
)

/* ------------------ With Tooltip ------------------ */

interface ToolButtonWithTooltipProps extends ToolButtonProps {
  label: string
  isLocked?: boolean
  kbd?: string
}

export const ToolButtonWithTooltip = observer<ToolButtonWithTooltipProps>(function ToolButtonWithTooltip({label,
  kbd,
  isLocked,
  ...rest}) {
    const {tools: {toggleToolLock}} = useWhiteboardStore()

  const handleDoubleClick = React.useCallback(() => {
    toggleToolLock()
  }, [])

  return (
    <Tooltip label={label[0].toUpperCase() + label.slice(1)} kbd={kbd}>
      <ToolButton
        {...rest}
        variant='primary'
        isToolLocked={isLocked && rest.isActive}
        onDoubleClick={handleDoubleClick}
      />
    </Tooltip>
  )
})



// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/ToolButton/ToolButton.tsx